/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios';
import PropTypes from 'prop-types';
import { useParams, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { List, Stack } from '@mui/material';
import { useLocales } from '../../../locales';
import { StyledSubheader } from './styles';
import LoadingScreen from '../../loading-screen/LoadingScreen';
import NavList from './NavList';
import MenusService from '../../../services/menus.service';
import AppCache from '../../../services/appcache';
import { PATH_MAIN } from '../../../routes/paths';
import { useMenuAccessStore } from '../../../store/menuAccessStore';

NavSectionVertical.propTypes = {
    sx: PropTypes.object,
    data: PropTypes.array,
};

export default function NavSectionVertical({ data, sx, ...other }) {
    const { translate } = useLocales();
    const [userMenuList, setUserMenuList] = useState([]);
    const [activePath, setActivePath] = useState(null);
    const userPath = [];

    const { masterName, pageType } = useParams();   
    const location = useLocation();
    const [refresh, setRefresh] = useState(0);
    const [loading, setLoading] = useState(false);
    const setUserMenuPermissions = useMenuAccessStore((state) => state.setUserMenuPermissions);

    useEffect(() => {
        const checkMenuRefresh = () => {
            const menuRefreshCount = sessionStorage.getItem('menuRefresh');
            if (Number(menuRefreshCount)) {
                setRefresh(prev => prev + 1);
                sessionStorage.removeItem('menuRefresh');
            }
        };
        if (masterName === 'user-wise-menu-access-rights' || location.pathname.includes('user-wise-menu-access-rights')) {
            checkMenuRefresh();
        }
    }, [masterName, pageType, location.pathname]);

    const toCamelCase = (key) =>
        key.charAt(0).toLowerCase() + key.slice(1);

    const transformKeysToCamelCase = (obj) => {
        if (Array.isArray(obj)) {
            return obj.map(transformKeysToCamelCase);
        }

        if (obj !== null && typeof obj === 'object') {
            return Object.fromEntries(
                Object.entries(obj).map(([key, value]) => [
                    toCamelCase(key),
                    transformKeysToCamelCase(value)
                ])
            );
        }

        return obj;
    };


    useEffect(() => {
        const fetchUserMenus = async () => {
            setLoading(true); // Start loading
            const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();
            if (CurrentLoggedInUser && CurrentLoggedInUser.Token) {
                axios.defaults.headers.common.authheader = `${CurrentLoggedInUser.Token}`;
                axios.defaults.headers.common['Content-Type'] = 'application/json';

                try {
                    const menuServiceInstance = await MenusService;
                    const response = await menuServiceInstance.GetUserMenus();

                    if (response.status === 200) {
                        const menuList = transformKeysToCamelCase(response.data.menuList);

                        setUserMenuList(menuList);
                        setUserMenuPermissions(menuList);
                    } else {
                        console.error("Error while fetching user data. Status:", response.status);
                        console.error("Error Message:", response.data);
                    }
                } catch (error) {
                    console.error("Error:", error);
                } finally {
                    setLoading(false); // Stop loading
                }
            } else {
                console.error("Token not available");
                setLoading(false); // Stop loading even if no token
            }
        };

        fetchUserMenus();
    }, [refresh, setUserMenuPermissions]);


    

    const handleActivePathChange = (newPath) => {
        setActivePath(newPath);
    };

    userPath.push(userMenuList.length > 0 && userMenuList.map(item => item.displayName));

    return (
        <Stack sx={sx} {...other}>
            {userMenuList.length > 0 && userMenuList.map((group) => {
                const key = group.subheader || group.displayName;
                return (
                    <List key={key} disablePadding sx={{ px: 1 }}>
                        {group.subheader && (
                            <StyledSubheader disableSticky>
                                {translate(group.subheader)}
                            </StyledSubheader>
                        )}
                        <NavList
                            key={group.displayName + PATH_MAIN.root + group.route}
                            userMenu={group}
                            depth={1}
                            userPath={userPath}
                            hasChild={!!group.children}
                            activePath={activePath}
                            onActivePathChange={handleActivePathChange}
                        />
                    </List>
                );
            })}
            {loading && (<LoadingScreen /> )}
        </Stack>
    );
}








